import { PlayerPlaceholder } from "components/placeholders/PlayerPlaceholder";
import { Suspense } from "react";
import { BaseThumbnail } from "../BaseThumbnail";
import { AssetDetailsResponse } from "@switcherstudio/api-core-client";

export const AssetThumbnail = ({ Url }: AssetDetailsResponse) => (
    <BaseThumbnail>
        {!Url ? (
            <PlayerPlaceholder />
        ) : (
            <Suspense fallback={<PlayerPlaceholder />}>
                <img src={Url} alt="Asset Thumbnail" />
            </Suspense>
        )}
    </BaseThumbnail>
);
